module.exports = "data:font/opentype;base64,"